import type { AnyMessage } from './types';

export class Queue {
  private readonly maxSize: number;
  private queue: AnyMessage[] = [];

  constructor(maxSize = 100) {
    this.maxSize = maxSize;
  }

  public enqueue(message: AnyMessage): void {
    if (this.queue.length >= this.maxSize) {
      console.warn('Message queue full, dropping oldest message');
      this.queue.shift();
    }
    this.queue.push(message);
  }

  public flush(): AnyMessage[] {
    const messages = [...this.queue];
    this.queue = [];
    return messages;
  }

  public isEmpty(): boolean {
    return this.queue.length === 0;
  }

  public size(): number {
    return this.queue.length;
  }

  public clear(): void {
    this.queue = [];
  }
}
